module.exports = {"attributes":{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.75 10C6.75 8.18579 8.18579 6.75 10 6.75 11.8142 6.75 13.25 8.18579 13.25 10 13.25 11.8142 11.8142 13.25 10 13.25 8.18579 13.25 6.75 11.8142 6.75 10zM10 8.25C9.01421 8.25 8.25 9.01421 8.25 10 8.25 10.9858 9.01421 11.75 10 11.75 10.9858 11.75 11.75 10.9858 11.75 10 11.75 9.01421 10.9858 8.25 10 8.25zM14.25 10C14.25 9.58579 14.5858 9.25 15 9.25L19 9.25C19.4142 9.25 19.75 9.58579 19.75 10 19.75 10.4142 19.4142 10.75 19 10.75L15 10.75C14.5858 10.75 14.25 10.4142 14.25 10zM.25 10C.25 9.58579.585786 9.25 1 9.25H5C5.41421 9.25 5.75 9.58579 5.75 10 5.75 10.4142 5.41421 10.75 5 10.75H1C.585786 10.75.25 10.4142.25 10z\" fill=\"currentColor\"/>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
